export const fetchPatientFiles = async (apiClient, patientId) => {
  const { data } = await apiClient.get(`/patient-files/patient/${patientId}`);
  return data;
};

export const fetchPatientFile = async (apiClient, id) => {
  const { data } = await apiClient.get(`/patient-files/${id}`);
  return data;
};

export const createPatientFile = async (apiClient, payload) => {
  const { data } = await apiClient.post('/patient-files', payload);
  return data;
};

export const registerLocalPatientFile = async (apiClient, patientId, payload) => {
  const { data } = await apiClient.post(`/patient-files/${patientId}/register-local`, payload);
  return data;
};

export const uploadPatientFile = async (apiClient, patientId, formData) => {
  const { data } = await apiClient.post(`/patient-files/${patientId}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const getPatientFileSignedUrl = async (apiClient, id) => {
  const { data } = await apiClient.get(`/patient-files/${id}/signed-url`);
  return data;
};

export const replacePatientFile = async (apiClient, patientId, id, formData) => {
  const { data } = await apiClient.post(`/patient-files/${patientId}/${id}/replace`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const updatePatientFile = async (apiClient, id, payload) => {
  const { data } = await apiClient.put(`/patient-files/${id}`, payload);
  return data;
};

export const deletePatientFile = async (apiClient, id) => {
  await apiClient.delete(`/patient-files/${id}`);
};

export const scanPatientFolder = async (apiClient, folderPath) => {
  const { data } = await apiClient.get(`/patient-files/scan-folder`, {
    params: { folderPath }
  });
  // Support new { files, found } response as well as legacy bare-array
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    return data; // { files: [...], found: true/false }
  }
  return { files: Array.isArray(data) ? data : [], found: true }; // legacy
};

export const getLocalFilePreviewUrl = (apiClient, filePath) => {
  // Use the baseURL from the provided client, or default to current window origin
  let baseUrl = apiClient?.defaults?.baseURL || '';
  
  // Clean trailing /api if present as we add it manually or rely on baseUrl structure
  baseUrl = baseUrl.replace(/\/api$/, '');
  
  const token = sessionStorage.getItem('token');
  return `${baseUrl}/api/patient-files/local-preview?path=${encodeURIComponent(filePath)}&token=${token}`;
};
